var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import { Button, Checkbox, Modal, ModalFooter, MessageBanner, } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekSelect } from "../../../components/inputs";
import { createPublisherRegistration } from "../../../api/publisherService";
import { REGISTRATION_AGENCIES } from "../../../utils/registrationUtils";
import { FOREIGN_PUBLISHER_MESSAGE_ID, isForeignPublisherError, } from "../../../utils/publisherActionError";
var REGISTRATION_ALREADY_EXISTS = "REGISTRATION_ALREADY_EXISTS";
export var AddRegistrationDialog = function (_a) {
    var open = _a.open, publisherId = _a.publisherId, preselectedAgency = _a.preselectedAgency, _b = _a.takenAgencies, takenAgencies = _b === void 0 ? [] : _b, _c = _a.alreadyExistsMessageId, alreadyExistsMessageId = _c === void 0 ? "ui-br-publishers.publishers.registrations.error.alreadyExists" : _c, onClose = _a.onClose, onSuccess = _a.onSuccess;
    var formatMessage = useIntl().formatMessage;
    var ky = useOkapiKy();
    var availableAgencies = REGISTRATION_AGENCIES.filter(function (option) { return !takenAgencies.includes(option); });
    // When only one agency remains, preselect it so the user cannot pick an invalid one.
    var defaultAgency = preselectedAgency !== null && preselectedAgency !== void 0 ? preselectedAgency : (availableAgencies.length === 1 ? availableAgencies[0] : "");
    var _d = useState(defaultAgency), agency = _d[0], setAgency = _d[1];
    var _e = useState(""), intent = _e[0], setIntent = _e[1];
    var _f = useState(false), withoutPrefixAssignment = _f[0], setWithoutPrefixAssignment = _f[1];
    var _g = useState(null), modalError = _g[0], setModalError = _g[1];
    var _h = useState(false), isSubmitting = _h[0], setIsSubmitting = _h[1];
    useEffect(function () {
        if (open) {
            setAgency(defaultAgency);
            setIntent("");
            setWithoutPrefixAssignment(false);
            setModalError(null);
            setIsSubmitting(false);
        }
        // defaultAgency is derived from preselectedAgency + takenAgencies
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, preselectedAgency]);
    var agencyLocked = !!preselectedAgency || availableAgencies.length <= 1;
    var handleRegister = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatedPublisher, error_1, message, _a, body, hasAlreadyExists, _b;
        var _c;
        var _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!agency || !intent) {
                        setModalError(formatMessage({
                            id: "ui-br-publishers.publishers.registrations.error.fieldsRequired",
                        }));
                        return [2 /*return*/];
                    }
                    if (!publisherId)
                        return [2 /*return*/];
                    setIsSubmitting(true);
                    setModalError(null);
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, 9, 10]);
                    return [4 /*yield*/, createPublisherRegistration(ky, publisherId, __assign({ registrationAgency: agency, registrationIntent: intent }, (withoutPrefixAssignment ? { withoutPrefixAssignment: true } : {})))];
                case 2:
                    updatedPublisher = _g.sent();
                    onSuccess(updatedPublisher);
                    return [3 /*break*/, 10];
                case 3:
                    error_1 = _g.sent();
                    _a = formatMessage;
                    _c = {};
                    return [4 /*yield*/, isForeignPublisherError(error_1)];
                case 4:
                    message = _a.apply(void 0, [(_c.id = (_g.sent())
                            ? FOREIGN_PUBLISHER_MESSAGE_ID
                            : "ui-br-publishers.publishers.registrations.error.registerFailed",
                            _c)]);
                    _g.label = 5;
                case 5:
                    _g.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, ((_e = (_d = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _d === void 0 ? void 0 : _d.json) === null || _e === void 0 ? void 0 : _e.call(_d))];
                case 6:
                    body = (_g.sent());
                    hasAlreadyExists = (_f = body === null || body === void 0 ? void 0 : body.errors) === null || _f === void 0 ? void 0 : _f.some(function (e) {
                        return (e === null || e === void 0 ? void 0 : e.type) === REGISTRATION_ALREADY_EXISTS ||
                            (e === null || e === void 0 ? void 0 : e.code) === REGISTRATION_ALREADY_EXISTS;
                    });
                    if (hasAlreadyExists) {
                        message = formatMessage({ id: alreadyExistsMessageId });
                    }
                    return [3 /*break*/, 8];
                case 7:
                    _b = _g.sent();
                    return [3 /*break*/, 8];
                case 8:
                    setModalError(message);
                    return [3 /*break*/, 10];
                case 9:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 10: return [2 /*return*/];
            }
        });
    }); };
    var footer = (React.createElement(ModalFooter, null,
        React.createElement(Button, { buttonStyle: "primary", onClick: handleRegister, disabled: isSubmitting },
            React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.registrations.button.register" })),
        React.createElement(Button, { onClick: onClose },
            React.createElement(FormattedMessage, { id: "ui-br-publishers.button.cancel" }))));
    return (React.createElement(Modal, { open: open, label: formatMessage({
            id: "ui-br-publishers.publishers.registrations.modal.title",
        }), footer: footer, onClose: onClose, size: "small", dismissible: true },
        modalError && React.createElement(MessageBanner, { type: "error" }, modalError),
        React.createElement(RecekSelect, { labelId: "ui-br-publishers.publishers.label.select.registration.agency", required: true, value: agency, disabled: agencyLocked, onChange: function (e) {
                return setAgency(e.target.value);
            }, dataOptions: __spreadArray(__spreadArray([], (agencyLocked
                ? []
                : [
                    {
                        value: "",
                        label: formatMessage({
                            id: "ui-br-publishers.publishers.label.registration.agency.default",
                        }),
                    },
                ]), true), availableAgencies.map(function (option) { return ({
                value: option,
                label: formatMessage({
                    id: "ui-br-publishers.publishers.label.registration.agency.".concat(option),
                }),
            }); }), true) }),
        React.createElement(RecekSelect, { labelId: "ui-br-publishers.publishers.label.select.registration.intent", required: true, value: intent, onChange: function (e) {
                setIntent(e.target.value);
                setWithoutPrefixAssignment(false);
            }, dataOptions: [
                {
                    value: "",
                    label: formatMessage({
                        id: "ui-br-publishers.publishers.label.registration.intent.default",
                    }),
                },
                {
                    value: "CONTINUOUS",
                    label: formatMessage({
                        id: "ui-br-publishers.publishers.label.registration.intent.CONTINUOUS",
                    }),
                },
                {
                    value: "ONE_OFF",
                    label: formatMessage({
                        id: "ui-br-publishers.publishers.label.registration.intent.ONE_OFF",
                    }),
                },
            ] }),
        intent === "CONTINUOUS" && (React.createElement(Checkbox, { label: formatMessage({
                id: "ui-br-publishers.publishers.registrations.checkbox.withoutPrefixAssignment",
            }), checked: withoutPrefixAssignment, onChange: function (e) {
                return setWithoutPrefixAssignment(e.target.checked);
            } }))));
};
